module.exports = __webpack_public_path__ + "img/Dantam Hair 11.9fdb312b.jpg";